import { render, staticRenderFns } from "./Intercos.vue?vue&type=template&id=cb2a4dc4&scoped=true"
import script from "./Intercos.vue?vue&type=script&lang=js"
export * from "./Intercos.vue?vue&type=script&lang=js"
import style0 from "./Intercos.vue?vue&type=style&index=0&id=cb2a4dc4&prod&scoped=true&lang=css"
import style1 from "../main.css?vue&type=style&index=1&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb2a4dc4",
  null
  
)

export default component.exports